import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center bg-background-50 px-4 text-center">
      <span className="pointer-events-none select-none font-heading text-[7rem] font-black leading-none text-background-200 md:text-[11rem]">
        404
      </span>
      <div className="relative z-10 -mt-6 max-w-md">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-background-100 text-primary-500">
          <i className="ri-compass-3-line text-2xl"></i>
        </div>
        <h1 className="mt-5 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          页面走丢了
        </h1>
        <p className="mt-2 text-sm text-foreground-600">
          你访问的页面不存在或已下线：<span className="text-foreground-800">{location.pathname}</span>
        </p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition hover:bg-primary-600"
          >
            返回首页
          </Link>
          <Link
            to="/search"
            className="whitespace-nowrap rounded-md border border-background-200 bg-background-100 px-6 py-3 text-sm text-foreground-800 transition hover:border-primary-300 hover:text-primary-400"
          >
            去搜索影视
          </Link>
        </div>
      </div>
    </div>
  );
}